import { createAsyncThunk } from "@reduxjs/toolkit";
import { GlobalContractsCommandDto } from "api/pricing";
import { pricingAPI } from "services/swagger-api";

export const fetchFunnelsByVariablesOrFees = createAsyncThunk(
  'guaranteeSlice/fetchFunnelsByVariablesOrFees',
  async (globalContractsCommandDto: GlobalContractsCommandDto, { dispatch }) => {
    const result = await pricingAPI.fetchGlobalContracts({
      globalContractsCommandDto
    });
    return result
  }
)
